/**
 * Constants for Promotions Management
 */

import { SelectOption } from "../../commonComponents/Selector/types";

export const STATUS_FILTER_OPTIONS: SelectOption[] = [
  { value: "all", label: "All Status" },
  { value: "draft", label: "Draft" },
  { value: "active", label: "Active" },
  { value: "paused", label: "Paused" },
  { value: "expired", label: "Expired" },
  { value: "cancelled", label: "Cancelled" },
];

export const TYPE_FILTER_OPTIONS: SelectOption[] = [
  { value: "all", label: "All Types" },
  { value: "percentage", label: "Percentage" },
  { value: "fixed", label: "Fixed Amount" },
  { value: "buy_one_get_one", label: "BOGO" },
];

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_STATUS_FILTER = "all";
export const DEFAULT_TYPE_FILTER = "all";

export const PROMOTION_TYPE_LABELS: Record<string, string> = {
  percentage: "Percentage",
  fixed: "Fixed Amount",
  buy_one_get_one: "BOGO",
};

export const PROMOTION_STATUS_COLORS: Record<string, string> = {
  active: "success",
  draft: "orange",
  paused: "warning",
  expired: "default",
  cancelled: "error",
};

